import { ENTITY_ID_SCANNER_PATTERN } from '@runloop/reflex-contract';
import { definePage, type PluginWebManifest } from '@reflex/plugin-api/web';

const page = definePage({
  path: '/chat',
  label: 'Chat',
  icon: 'MessageSquare',
  group: 'main',
  componentPath: '@reflex/plugin-chat/web/ChatPage',
  maturityStage: 'preview',
  description: 'Talk to an LLM right inside the workspace.',
  details:
    'A first-class chat surface that talks to your configured LLM providers (Anthropic, OpenAI, Google, xAI). Conversations are scoped per user, support file attachments, and stream responses through the same WebSocket connection used everywhere else.',
  features: [
    'Multi-model chat (Anthropic, OpenAI, Google, xAI)',
    'Streaming responses with stop / regenerate',
    'File and image attachments',
    'Conversation history + sidebar navigation',
  ],
});

export const chatWeb: PluginWebManifest = {
  ...page.web,
  routes: [
    ...page.web.routes!,
    { path: '/chat/:conversationId', componentPath: '@reflex/plugin-chat/web/ChatPage' },
  ],
  marketingPreviews: [
    {
      id: 'chat-conversation',
      label: 'Live chat conversation',
      description: 'A short illustrative thread rendered with the real message list.',
      surface: 'panel',
      componentPath: '@reflex/plugin-chat/web/ChatMessagePreview',
    },
    {
      id: 'chat-launcher',
      label: 'Recent chats panel',
      description: 'How the sidebar surfaces ongoing conversations after installing.',
      surface: 'card',
      componentPath: '@reflex/plugin-chat/web/ChatLauncherPreview',
      order: 10,
    },
  ],
  // Badge prefixed entity ids (agt_..., msg_..., plugin-owned kinds) wherever
  // agent output is rendered. Registered here rather than in core so the chat
  // plugin owns the behavior; because the SDK chat view and the classic agent
  // stream both render through the shared `MarkdownContent`, one text scanner
  // lights the badges up on both surfaces.
  contentScanners: [
    {
      id: 'chat:entity-id',
      target: 'text',
      pattern: ENTITY_ID_SCANNER_PATTERN,
      componentPath: '@reflex/plugin-chat/web/components/EntityIdBadgeScanner',
    },
  ],
};
